import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EfemeridesResponse } from 'src/app/modal/efemerides/efemerides-response';

@Injectable({
  providedIn: 'root'
})
export class EfemeridesService {

  constructor(private httpClient: HttpClient) { }

  obtenerEfemerides() {
    let url = `${environment.urlBase}${environment.efemerides}`;

    return this.httpClient.get<EfemeridesResponse>(url).pipe(
      map(data => {
        let response: EfemeridesResponse;
        response = data;
        if(data.httpStatus === 200 && data.response.codeResponse === "0000") {
          return response;
        }
        return null;
      },
      error => {
        return null;
      }))
  }

  /**
   * Obtener efemérides por fecha específica usando SP_SEARCH_EFEMERIDES
   * @param dia Día del mes (1-31)
   * @param mes Mes (1-12)
   */
  obtenerEfemeriadesPorFecha(dia: number, mes: number) {
    let url = `${environment.urlBase}${environment.efemerides}/search?dia=${dia}&mes=${mes}`;

    return this.httpClient.get<EfemeridesResponse>(url).pipe(
      map(data => {
        let response: EfemeridesResponse;
        response = data;
        if(data.httpStatus === 200 && data.response.codeResponse === "0000") {
          return response;
        }
        return null;
      },
      error => {
        return null;
      }))
  }
}
